import React, { useState } from "react";
import { Button, Input, Modal, Space } from "antd";
import { changePassword } from "../../api/auth/authApi";
import { useNotifications } from "../../context/NotificationContext";

interface PasswordResetModalProps {
	open: boolean;
	onClose: () => void;
}

// CU-14ygtkj8nr3: the self-password-reset flow, moved out of Sidebar.tsx so the Customer shell reuses it rather than copying it.
const PasswordResetModal: React.FC<PasswordResetModalProps> = ({ open, onClose }) => {
	const { showError, showSuccess } = useNotifications();
	const [resetting, setResetting] = useState(false);
	const [currentPw, setCurrentPw] = useState("");
	const [newPw, setNewPw] = useState("");
	const [confirmPw, setConfirmPw] = useState("");

	const onResetPassword = async () => {
		if (newPw !== confirmPw) {
			showError("Passwords do not match");
			return;
		}
		setResetting(true);
		try {
			await changePassword(currentPw, newPw, confirmPw);
			showSuccess("Password reset successfully");
			onClose();
			setCurrentPw("");
			setNewPw("");
			setConfirmPw("");
		} catch (e: any) {
			const fields = e.response?.data?.details?.fields;
			showError(fields?.current_password?.[0] || fields?.password?.[0] || e.response?.data?.message || "Failed to reset password");
		} finally {
			setResetting(false);
		}
	};

	return (
		<Modal
			title="Reset Password"
			open={open}
			onCancel={onClose}
			width={400}
			footer={[
				<Button key="cancel" onClick={onClose} disabled={resetting}>
					Cancel
				</Button>,
				<Button key="ok" type="primary" onClick={onResetPassword} loading={resetting}>
					Reset
				</Button>,
			]}
		>
			<Space direction="vertical" style={{ width: "100%", paddingTop: 8 }}>
				<Input.Password placeholder="Current password" value={currentPw} onChange={(e) => setCurrentPw(e.target.value)} />
				<Input.Password placeholder="New password" value={newPw} onChange={(e) => setNewPw(e.target.value)} />
				<Input.Password placeholder="Confirm password" value={confirmPw} onChange={(e) => setConfirmPw(e.target.value)} />
			</Space>
		</Modal>
	);
};

export default PasswordResetModal;
